import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { withStyles } from '@material-ui/core/styles';
import { fade } from '@material-ui/core/styles/colorManipulator';
import ActionDelete from '@material-ui/icons/FileCopy';
import classnames from 'classnames';
import { translate, crudDelete, startUndoable } from 'ra-core';
import IconCancel from '@material-ui/icons/Cancel';
import IconConfirm from '@material-ui/icons/ConfirmationNumberRounded';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { Button } from 'react-admin';
import decodeJwt from 'jwt-decode';
const config = require('../../config.json');

const styles = (theme) => ({
  deleteButton: {
    color: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: fade(theme.palette.primary.main, 0.12),
      // Reset on mouse devices
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    }
  }
});

class DuplicateCostButtonWithConfirmation extends Component {
  state = {
    showDialog: false,
    showDialog2: false,
    showDialog3: false,
    error: '',
    token: decodeJwt(localStorage.getItem("token")).access_token
  };

  handleClick = () => {
    this.setState({ showDialog: true });
  };

  handleCloseClick = () => {
    this.setState({ showDialog: false });
  };

  handleClick2 = () => {
    this.setState({ showDialog2: true });
  };

  backButton = () => {
    var getUrl = window.location;
    var baseUrl = getUrl.protocol + "//" + getUrl.host
    const { record } = this.props;
    window.location = baseUrl + `/#/cost_centers/${record.costId}/show`;
  }

  handleClick3 = () => {
    this.setState({ showDialog3: true });
  };

  handleCloseClick3 = () => {
    this.setState({ showDialog3: false });
    this.backButton();
  };
  
  handleCloseClick2 = () => {
    this.setState({ showDialog2: false });
    this.backButton();
    var getUrl = window.location;
    var baseUrl = getUrl.protocol + "//" + getUrl.host
    window.location = baseUrl + `/#/cost_centers`;
  };

  megaBackButton = () => {
    var getUrl = window.location;
    var baseUrl = getUrl.protocol + "//" + getUrl.host
    window.location = baseUrl + `/#/cost_centers`;
  }


  handleDuplicate = async (event) => {
    event.preventDefault();
    this.setState({ showDialog: false });
    const { record } = this.props;
    await fetch(config.API_URL + "/cost_centers/" + record.id + "/duplication", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': this.state.token
      },
    })
      .then(res => {
        if (res.status === 201) {
          return true;
        } else {
          return res.json();
        }
      })
      .then(data => {
        if (data === true) {
          this.setState({ showDialog2: true });
        } else {
          this.setState({ showDialog3: true, error: data.error });
        }
      })
      .catch(err => {
        console.log(err);
        this.setState({ showDialog3: true, error: err });
      })
  };

  render() {
    const { showDialog, showDialog2, showDialog3 } = this.state;
    const { label = 'ra.action.delete', classes = {}, className } = this.props;
    if (this.props.record === undefined) {
      this.megaBackButton();
      return null;
    }
    return (
      <Fragment>
        <Button onClick={this.handleClick} label={label} className={classnames('ra-delete-button', classes.deleteButton, className)} key="button">
          <ActionDelete />
        </Button>
        <Dialog fullWidth open={showDialog} onClose={this.handleCloseClick} aria-label="Are you sure?">
          <DialogTitle>{"¿Deseas duplicar este centro de costo y sus precios?"}</DialogTitle>
          <DialogContent>
            <div>
              <p>SE DUPLICARÁ EL CENTRO DE COSTOS Y LOS PRECIOS QUE ESTÉN EN ÉL.</p>
              <p>EL NUEVO NOMBRE SERÁ: "{this.props.record.name + "_NUEVO"}"</p>
              <p>IR A CENTRO DE COSTO para ver cambios.</p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDuplicate} label={label} className={classnames('ra-delete-button', classes.deleteButton, className)} key="button">
              <ActionDelete />
            </Button>
            <Button label="Cancelar" onClick={this.handleCloseClick}>
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog fullWidth open={showDialog2} onClose={this.handleCloseClick2} aria-label="Are you sure?">
          <DialogTitle>{"Duplicación"}</DialogTitle>
          <DialogContent>
            <div>
              <p>Se ha duplicado correctamente el centro de costo.</p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button label="Confirmar" onClick={this.handleCloseClick2}>
              <IconConfirm />
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog fullWidth open={showDialog3} onClose={this.handleCloseClick3} aria-label="Are you sure?">
          <DialogTitle>{"Error de duplicación"}</DialogTitle>
          <DialogContent>
            <div>
              <p>Centro de costo no puede ser duplicado debido a:</p>
              <p>{this.state.error}</p>
            </div>
          </DialogContent>
          <DialogActions>
            <Button label="Confirmar" onClick={this.handleCloseClick3}>
              <IconConfirm />
            </Button>
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

DuplicateCostButtonWithConfirmation.propTypes = {
  basePath: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  dispatchCrudDelete: PropTypes.func.isRequired,
  label: PropTypes.string,
  record: PropTypes.object,
  redirect: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.func]),
  resource: PropTypes.string.isRequired,
  startUndoable: PropTypes.func,
  translate: PropTypes.func,
  undoable: PropTypes.bool
};

DuplicateCostButtonWithConfirmation.defaultProps = {
  redirect: 'list',
  undoable: true
};

export default compose(
  connect(
    null,
    { startUndoable, dispatchCrudDelete: crudDelete }
  ),
  translate,
  withStyles(styles)
)(DuplicateCostButtonWithConfirmation);